import type { GridSortModel } from '@mui/x-data-grid-pro';
import { Abonent } from '@shared/types/osi/abonents';
import { AreaType } from '@shared/types/dictionaries';

export interface IOsiAbonentsWidgetViewModel {
  abonents: Abonent[];
  sortedAbonents: Abonent[];
  // Вариант А: контролируемая моделью сортировка (грид в режиме sortingMode="server").
  sortModel: GridSortModel;
  setSortModel: (model: GridSortModel) => void;
  isLoading: boolean;
  downloadReport: () => Promise<void>;
  isCreatingDialogOpen: boolean;
  startCreatingAbonent: () => void;
  stopCreatingAbonent: () => void;
  isEditingDialogOpen: boolean;
  startEditingAbonent: (abonent: Abonent) => void;
  stopEditingAbonent: () => void;

  reloadCb: any;

  totalAbonents: number;
  totalSquare: string;
  totalParkingPlaces: number;

  osiId: number | null;
  areaTypes: AreaType[];
  cancelCreating: () => void;
  addAbonent: () => string;
  updateAbonent: (abonent: Abonent) => void;
  // OSI-806: добавление созданного помещения в локальный список вместо прямого vm.abonents.push(...).
  // Внутри — условное обновление osiInfo.hasChildAbonents, от которого зависит показ чекбокса
  // «Свернуть дочерние помещения». Сайд-эффект держим в VM, чтобы не дублировать условие в UI.
  pushAbonent: (abonent: Abonent) => void;
  saveTemporaryRow: (tempRow: any) => void;
  clearTemporaryRow: () => void;
  importAbonents: (file: File) => Promise<void>;
}

export const IOsiAbonentsWidgetViewModelToken = Symbol.for('IOsiAbonentsWidgetViewModel');
